import axios from "axios";
import router from "@/router"; // 路由配置

import crypto from "../assets/js/encrypt"; // 加密工具类

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL_JAVA,
  timeout: 60 * 1000,
});

service.interceptors.request.use(
  config => {
    const timestamp = Date.now() + 1000 * 60;
    const token = localStorage.getItem("token");
    config.headers = {
      "Content-Type": "application/json",
      timestamp: timestamp,
      sign: crypto.generateSign(timestamp),
    };
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
// 封装响应拦截，判断token是否过期
service.interceptors.response.use(
  response => {
    const { data } = response;
    if (data.code === 20001 || data.code === 2) {
      sessionStorage.clear();
      localStorage.clear();
      router.push("/login");
    }
    return Promise.resolve(response.data);
  },
  err => {
    if (err && err.response != undefined) {
      switch (err.response.status) {
        case 400:
          console.log("错误请求");
          break;
        case 401:
          console.log("未授权，请重新登录");
          break;
        case 403:
          console.log("拒绝访问");
          break;
        case 404:
          console.log("请求错误,未找到该资源");
          break;
        case 405:
          console.log("请求方法未允许");
          break;
        case 408:
          console.log("请求超时");
          break;
        case 500:
          console.log("服务器端出错");
          break;
        case 501:
          console.log("网络未实现");
          break;
        case 502:
          console.log("网络错误");
          break;
        case 503:
          console.log("服务不可用");
          break;
        case 504:
          console.log("网络超时");
          break;
        case 505:
          console.log("http版本不支持该请求");
          break;
        default:
          console.log("连接错误$ {err.response.status}");
      }
    } else {
      return Promise.resolve({
        code: 0,
        msg: "网络问题，请稍后再试。",
        data: "",
      });
    }
    return Promise.resolve(err.response);
  }
);
export default service;
